'use strict';

/* Libs */
import 'paypal-checkout';
import 'angularjs-stripe-elements'

/* Views */
import PaymentList from './list/payment-list.component';
import BankingAccountList from '../user/banking-accounts/list/banking-accounts-list.component';
import BankingAccountEdit from '../user/banking-accounts/edit/banking-accounts-edit.component';

/* Components */
import PaymentComponent from '../../components/payment/payment.component';
import AccountVerificationComponent from '../../components/banking-account-verification/banking-account-verification.component';

/* Services */
import PaymentService from '../../services/payment/payment.service';
import BankingAccountsService from '../../services/banking-accounts/banking-accounts.service';

export default angular.module('conduuApp.payment', ['paypal-button', 'angularjs-stripe-elements',
  PaymentList, PaymentComponent, PaymentService, BankingAccountsService, BankingAccountList, BankingAccountEdit, AccountVerificationComponent])
  .name;



// WEBPACK FOOTER //
// ./client/app/payment/index.js